function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgZip = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.921
    },
    fill: "#0a6afe",
    d: "M 10.5,-0.5 C 22.1667,-0.5 33.8333,-0.5 45.5,-0.5C 50.1406,3.80525 54.8073,8.13858 59.5,12.5C 59.5,28.1667 59.5,43.8333 59.5,59.5C 43.1667,59.5 26.8333,59.5 10.5,59.5C 10.5,57.1667 10.5,54.8333 10.5,52.5C 11.1499,52.1961 11.8165,51.8627 12.5,51.5C 13.4656,53.396 13.7989,55.396 13.5,57.5C 28.0097,57.8293 42.3431,57.4959 56.5,56.5C 56.5,42.5 56.5,28.5 56.5,14.5C 52.1667,14.5 47.8333,14.5 43.5,14.5C 43.5,10.5 43.5,6.5 43.5,2.5C 40.5,2.5 37.5,2.5 34.5,2.5C 27.8333,2.5 21.1667,2.5 14.5,2.5C 13.5067,11.3178 13.1734,20.3178 13.5,29.5C 25.5,29.5 37.5,29.5 49.5,29.5C 49.5,36.1667 49.5,42.8333 49.5,49.5C 37.3217,49.1716 25.3217,49.5049 13.5,50.5C 12.5,50.5 11.5,50.5 10.5,50.5C 7.06131,50.2529 3.72797,50.5863 0.5,51.5C 0.166667,51.5 -0.166667,51.5 -0.5,51.5C -0.5,43.8333 -0.5,36.1667 -0.5,28.5C 3.16667,28.5 6.83333,28.5 10.5,28.5C 10.5,18.8333 10.5,9.16667 10.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73abfa",
    d: "M 14.5,2.5 C 14.5,2.83333 14.5,3.16667 14.5,3.5C 14.5,11.8333 14.5,20.1667 14.5,28.5C 17.8333,28.5 21.1667,28.5 24.5,28.5C 27.5,28.5 30.5,28.5 33.5,28.5C 38.1667,28.5 42.8333,28.5 47.5,28.5C 48.791,28.2627 49.791,28.596 50.5,29.5C 50.1667,29.5 49.8333,29.5 49.5,29.5C 37.5,29.5 25.5,29.5 13.5,29.5C 13.1734,20.3178 13.5067,11.3178 14.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9f1f9",
    d: "M 14.5,3.5 C 18.1817,3.3347 21.8484,3.50137 25.5,4C 24.5175,12.081 24.1842,20.2476 24.5,28.5C 21.1667,28.5 17.8333,28.5 14.5,28.5C 14.5,20.1667 14.5,11.8333 14.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2f4",
    d: "M 14.5,3.5 C 14.5,3.16667 14.5,2.83333 14.5,2.5C 21.1667,2.5 27.8333,2.5 34.5,2.5C 33.5301,11.0823 33.1968,19.7489 33.5,28.5C 30.5,28.5 27.5,28.5 24.5,28.5C 24.1842,20.2476 24.5175,12.081 25.5,4C 21.8484,3.50137 18.1817,3.3347 14.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ab8f1",
    d: "M 43.5,14.5 C 47.8333,14.5 52.1667,14.5 56.5,14.5C 56.5,28.5 56.5,42.5 56.5,56.5C 56.1667,56.5 55.8333,56.5 55.5,56.5C 55.5,42.8333 55.5,29.1667 55.5,15.5C 51.2984,15.8168 47.2984,15.4834 43.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97bce6",
    d: "M 50.5,30.5 C 50.5,30.1667 50.5,29.8333 50.5,29.5C 49.791,28.596 48.791,28.2627 47.5,28.5C 47.5,24.5 47.5,20.5 47.5,16.5C 49.8333,16.5 52.1667,16.5 54.5,16.5C 54.5,29.5 54.5,42.5 54.5,55.5C 50.3196,55.8115 46.3196,55.1448 42.5,53.5C 45.4281,52.5159 48.4281,52.1826 51.5,52.5C 51.825,44.9809 51.4916,37.6476 50.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e3ff",
    d: "M 22.5,34.5 C 22.5,34.8333 22.5,35.1667 22.5,35.5C 21.1769,37.4714 19.8435,39.4714 18.5,41.5C 19.6888,42.4287 21.0222,42.762 22.5,42.5C 21.6661,43.7479 20.3328,44.4146 18.5,44.5C 16.9549,44.4892 15.6216,44.1558 14.5,43.5C 15.4867,41.5266 16.4867,39.5266 17.5,37.5C 16.5,36.8333 15.5,36.1667 14.5,35.5C 17.0865,34.52 19.7531,34.1866 22.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5598ff",
    d: "M 22.5,35.5 C 22.5,35.1667 22.5,34.8333 22.5,34.5C 23.1667,34.5 23.8333,34.5 24.5,34.5C 23.931,38.3293 24.5977,41.6627 26.5,44.5C 22.3171,45.8111 17.9838,45.8111 13.5,44.5C 13.6236,43.8933 13.9569,43.56 14.5,43.5C 15.6216,44.1558 16.9549,44.4892 18.5,44.5C 20.3328,44.4146 21.6661,43.7479 22.5,42.5C 23.8333,40.1667 23.8333,37.8333 22.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1ecff",
    d: "M 24.5,34.5 C 26.4023,37.3373 27.069,40.6707 26.5,44.5C 24.5977,41.6627 23.931,38.3293 24.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2371ff",
    d: "M 22.5,35.5 C 23.8333,37.8333 23.8333,40.1667 22.5,42.5C 21.0222,42.762 19.6888,42.4287 18.5,41.5C 19.8435,39.4714 21.1769,37.4714 22.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0e2ff",
    d: "M 28.5,34.5 C 31.1194,34.2317 33.6194,34.565 36,35.5C 37.5685,39.9174 36.0685,41.9174 31.5,41.5C 31.5,42.8333 31.5,44.1667 31.5,45.5C 30.5,45.5 29.5,45.5 28.5,45.5C 28.5,41.8333 28.5,38.1667 28.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4285ff",
    d: "M 31.5,36.5 C 33.4646,36.9483 33.7979,37.9483 32.5,39.5C 31.6143,38.675 31.281,37.675 31.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3787fb",
    d: "M 49.5,29.5 C 49.8333,29.5 50.1667,29.5 50.5,29.5C 50.5,29.8333 50.5,30.1667 50.5,30.5C 50.5,37.1667 50.5,43.8333 50.5,50.5C 42.1667,50.5 33.8333,50.5 25.5,50.5C 21.8333,50.5 18.1667,50.5 14.5,50.5C 14.1667,50.5 13.8333,50.5 13.5,50.5C 25.3217,49.5049 37.3217,49.1716 49.5,49.5C 49.5,42.8333 49.5,36.1667 49.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18
    },
    fill: "#f1f6ff",
    d: "M 10.5,50.5 C 10.5,51.1667 10.5,51.8333 10.5,52.5C 6.95815,52.8128 3.62482,52.4794 0.5,51.5C 3.72797,50.5863 7.06131,50.2529 10.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5eef9",
    d: "M 14.5,50.5 C 18.1667,50.5 21.8333,50.5 25.5,50.5C 28.977,51.3227 32.6437,51.8227 36.5,52C 33.7737,52.1816 31.1071,52.6816 28.5,53.5C 29.1925,54.5178 29.8592,55.5178 30.5,56.5C 25.1667,56.5 19.8333,56.5 14.5,56.5C 14.5,54.5 14.5,52.5 14.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8d1ef",
    d: "M 34.5,2.5 C 37.5,2.5 40.5,2.5 43.5,2.5C 43.5,6.5 43.5,10.5 43.5,14.5C 47.2984,15.4834 51.2984,15.8168 55.5,15.5C 55.5,29.1667 55.5,42.8333 55.5,56.5C 47.1667,56.5 38.8333,56.5 30.5,56.5C 29.8592,55.5178 29.1925,54.5178 28.5,53.5C 31.1071,52.6816 33.7737,52.1816 36.5,52C 32.6437,51.8227 28.977,51.3227 25.5,50.5C 33.8333,50.5 42.1667,50.5 50.5,50.5C 50.5,43.8333 50.5,37.1667 50.5,30.5C 51.4916,37.6476 51.825,44.9809 51.5,52.5C 48.4281,52.1826 45.4281,52.5159 42.5,53.5C 46.3196,55.1448 50.3196,55.8115 54.5,55.5C 54.5,42.5 54.5,29.5 54.5,16.5C 52.1667,16.5 49.8333,16.5 47.5,16.5C 47.5,20.5 47.5,24.5 47.5,28.5C 42.8333,28.5 38.1667,28.5 33.5,28.5C 33.1968,19.7489 33.5301,11.0823 34.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5698fc",
    d: "M 10.5,50.5 C 11.5,50.5 12.5,50.5 13.5,50.5C 13.8333,50.5 14.1667,50.5 14.5,50.5C 14.5,52.5 14.5,54.5 14.5,56.5C 19.8333,56.5 25.1667,56.5 30.5,56.5C 38.8333,56.5 47.1667,56.5 55.5,56.5C 55.8333,56.5 56.1667,56.5 56.5,56.5C 42.3431,57.4959 28.0097,57.8293 13.5,57.5C 13.7989,55.396 13.4656,53.396 12.5,51.5C 11.8165,51.8627 11.1499,52.1961 10.5,52.5C 10.5,51.8333 10.5,51.1667 10.5,50.5 Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/zip.148a41e1.svg";
export { ForwardRef as ReactComponent };